import { MenuItem, Typography } from '@mui/material';

import { DeleteIcon } from '@/assets/icons';
import { useFloorplanAdminStore } from '../store';

type Props = {
  onClick: () => void;
};

export const DeleteOption = ({ onClick }: Props) => {
  const selectedFloorplansIds = useFloorplanAdminStore((state) => state.selectedFloorplanIdsState);
  const amountSelected = selectedFloorplansIds.length;

  return (
    <MenuItem
      onClick={onClick}
      component='button'
      sx={{
        display: 'flex',
        gap: '14px',
        width: '100%',
        paddingLeft: '21px',
        paddingRight: '21px',
      }}
    >
      <DeleteIcon />
      <Typography>
        {`Delete ${amountSelected} floorplan${amountSelected > 1 ? 's' : ''}`}
      </Typography>
    </MenuItem>
  );
};
